import { TextField } from "@mui/material";
import "./debounced-search-bar.css";
import { useCallback } from "react";
import { SearchField } from "../form/search-field";

export interface DebouncedSearchBarProps {
    value: string;
    onDebounceChange(text: string): void;
    onValueChange(text: string): void;
    placeHolder?: string;
    icon: string | React.FunctionComponent<any> | React.ComponentClass<any>;
}

const debounce = (func: any, delay: any) => {
    let timeoutId: any;
    return (...args: any) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
    };
};

function DebouncedSearchBar(props: DebouncedSearchBarProps) {
    const { value, onDebounceChange, onValueChange, placeHolder, icon } = props;

    const handleSearch = useCallback(
        debounce((searchTerm: any) => {
            if (onDebounceChange) onDebounceChange(searchTerm);
        }, 500),
        []
    );

    return (
        <div className="search-field-container">
            {/* <TextField
                value={value}
                onChange={(event) => {
                    handleSearch(event.target.value);
                    onValueChange(event.target.value);
                }}
                placeholder={placeHolder}
                sx={{ background: "white" }}
            /> */}
            <SearchField
                inputValue={value}
                onValueChange={(value) => {
                    handleSearch(value);
                    onValueChange(value);
                }}
                placeholder={placeHolder}
                icon={icon}
            />
        </div>
    );
}

export default DebouncedSearchBar;
